module.exports = __webpack_public_path__ + "static/media/arrow-complete-down.b7b7a8d8.svg";